"use client";

import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { MdQrCode } from "react-icons/md";

import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";

import { StepperFlowActionsProps } from "./types";

import "./styles.scss";

export const StepperFlowActions = ({
  showBack = true,
  backAriaLabel,
  showPreview,
  previewAriaLabel,
  nextLabel,
  nextLoadingLabel,
  onBack,
  onPreview,
  onNext,
  showNext,
  isNextLoading,
  isNextDisabled,
  stepper,
}: StepperFlowActionsProps) => {
  return (
    <div
      className="StepperFlowActions"
      data-testid="stepper-flow-actions"
    >
      <div className="StepperFlowActions__back">
        {showBack ? (
          <ButtonLib
            id="qr-editor-previous-step-button"
            shape="outlined"
            onClick={onBack}
            dataQA="qr-editor-previous-step-button"
            ariaLabel={backAriaLabel}
            iconLeft={<FiChevronLeft />}
          />
        ) : (
          <div className="StepperFlowActions__back-spacer" />
        )}
      </div>

      {stepper ? <div className="StepperFlowActions__stepper">{stepper}</div> : null}

      <div className="StepperFlowActions__actions">
        {showPreview ? (
          <ButtonLib
            shape="ghost"
            id="qr-editor-preview-button"
            dataQA="qr-editor-preview-button"
            onClick={onPreview}
            iconLeft={<MdQrCode />}
            ariaLabel={previewAriaLabel}
          />
        ) : null}

        {showNext ? (
          <ButtonLib
            id="qr-editor-next-step-button"
            variant="secondary"
            label={isNextLoading && nextLoadingLabel ? nextLoadingLabel : nextLabel}
            dataQA="qr-editor-next-step-button"
            iconRight={<FiChevronRight />}
            onClick={onNext}
            isLoading={isNextLoading}
            disabled={isNextDisabled}
          />
        ) : (
          <div className="StepperFlowActions__next-spacer" />
        )}
      </div>
    </div>
  );
};
